module.exports = __webpack_public_path__ + "static/media/icon-catalog-done.109e71f6.svg";